import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Starfield } from "../marketing/Starfield";
import { Reveal } from "../anim";

export function GuideHero({ guide }) {
  return (
    <section className="surface-night with-bloom relative overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-28" data-testid="guide-hero">
      <Starfield density="medium" topBias={0.5} seed={Number(guide.num) + 20} className="z-[1]" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <Link to="/learn#start" className="inline-flex items-center font-mono text-[11px] uppercase tracking-[0.15em] text-champagne hover:text-champ-light transition-colors" data-testid="guide-back-link">
          <ArrowLeft className="mr-2 h-3.5 w-3.5" /> All starting points
        </Link>
        <div className="mt-10 grid gap-12 lg:grid-cols-12 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="lg-eb text-champagne" data-testid="guide-eyebrow">Starting point {guide.num}</p>
            <h1 className="trex-h1 text-bone mt-6" data-testid="guide-title">
              {guide.titleLead}<em className="accent-italic">{guide.titleAccent}</em>{guide.titleTail}
            </h1>
            <p className="mt-7 max-w-xl text-lg lg:text-xl leading-relaxed text-bone/75" data-testid="guide-dek">{guide.dek}</p>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.15em] text-bone/50">{guide.readTime}</p>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={200}>
              <div className="lg-glance" data-testid="guide-glance">
                <p className="lg-eb text-champagne/80">At a glance</p>
                <ul className="mt-5 list-none p-0 m-0">
                  {guide.glance.map((g) => <li key={g}>{g}</li>)}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
